
import type { ButtonHTMLAttributes, ReactNode } from 'react';


interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  children: ReactNode;
}

export default function Button({ 
  variant = 'primary', 
  size = 'md', 
  children, 
  className = '', 
  ...props 
}: ButtonProps) {
  const baseClasses = 'font-semibold rounded-lg cursor-pointer whitespace-nowrap flex items-center justify-center transition-all duration-300 ease-in-out hover-effect';
  
  const variantClasses = {
    primary: 'bg-gradient-to-r from-emerald-600 to-emerald-700 text-white shadow-lg border-2 border-emerald-600 btn-primary',
    secondary: 'bg-gradient-to-r from-teal-600 to-teal-700 text-white shadow-lg border-2 border-teal-600 btn-secondary',
    outline: 'border-2 border-emerald-600 text-emerald-600 bg-transparent btn-outline'
  };
  
  const sizeClasses = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg'
  };
  
  return (
    <button 
      className={`${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}
